// Modal Forms
export function modalForm() {
  const body = document.body;

  [...document.querySelectorAll('.js-modal-open')]?.forEach( modal => {
    modal.addEventListener('click', function(e){
      e.preventDefault();
      body.classList.add('modal-open');
    })
  });

  [...document.querySelectorAll('.js-modal-close')]?.forEach( modal => {
    modal.addEventListener('click', function(e){
      e.preventDefault();
      body.classList.remove('modal-open');
    })
  });
}